module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop', {
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-contents",
    style: ({
      animation: _vm.animation
    })
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child flexleft",
      class: 'animation-from-right-' + index,
      on: {
        "click": function($event) {
          return _vm.todetail(item.url)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": _vm.$index.addurl(item.thumb_url),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.digest))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("发布时间 : " + _vm._s(item.create_time))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "hide-on-single-page": _vm.value,
      "current-page": _vm.currentPage,
      "page-size": 15,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.addPage
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-432ff09a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ctRibao/ctRibao.vue
// module id = 1089
// module chunks = 1